import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import api from "APP_ROOT/api";
import pojo from "LIB/pojos";
import { CONDITION_TYPES } from "MODULES/Receiving/constants";
import { DO_NOT_LIST, LIST } from "MODULES/inventories/constants";
import Form from "./Form";
import { displayFields } from "./constants";

export default function UpdateSrpStatus({ editing, close, inventory }) {
  const inventories = usePartInventories(inventory.get("part_id"), editing);
  const [inventoriesSelected, setInventoriesSelected] = useState([]);

  const initialValues = {
    inventories: inventories.map(i => {
      i.display_condition = get(CONDITION_TYPES, `${i.condition}.label`);
      return pojo(i).pick("id", ...Object.keys(displayFields));
    })
  };

  return (
    <Modal open={editing} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Update SRP</h4>
      </Header>
      <Form
        close={close}
        initialValues={initialValues}
        inventories={inventories}
        inventoriesSelected={inventoriesSelected}
        setInventoriesSelected={setInventoriesSelected}
        enableReinitialize
      />
    </Modal>
  );
}

UpdateSrpStatus.propTypes = {
  editing: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  inventory: PropTypes.shape({})
};

// Custom Hooks

function usePartInventories(partId, editing) {
  const [inventories, setInventories] = useState([]);

  useEffect(
    () => {
      api.parts.inventories
        .search(partId, {
          sellable_status: [DO_NOT_LIST, LIST].join(","),
          limit: 1000
        })
        .then(resp => setInventories(resp.data.results));

      return function cleanup() {};
    },
    [editing]
  );

  return inventories;
}



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/UpdateSrpStatus/UpdateSrpStatus.jsx